import { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { validarEstatusDispositivo } from '../../services/Custodia/CustodiaService';

/**
 * Botón "Validar estatus": consulta si un dispositivo GPS reportó recientemente
 * (usar / no usar) antes de asignarlo a la custodia. Muestra el resultado en un
 * OverlayPanel. `mini` = solo ícono (para celdas de tabla).
 */
export const ValidarEstatusButton = ({ dispositivoId, disabled, mini = false }) => {
    const op = useRef(null);
    const [res, setRes] = useState(null);
    const [loading, setLoading] = useState(false);

    const onClick = async (e) => {
        if (!dispositivoId) return;
        try {
            setLoading(true);
            const r = await validarEstatusDispositivo(dispositivoId);
            setRes(r.data);
        } catch (err) {
            setRes({ usar: false, mensaje: 'No se pudo validar el estatus.' });
        } finally {
            setLoading(false);
            op.current?.show(e, e.currentTarget);
        }
    };

    return (
        <>
            <Button
                type="button"
                icon="pi pi-map-marker"
                label={mini ? undefined : 'Validar estatus'}
                className={mini ? 'p-button-rounded p-button-text p-button-secondary' : 'p-button-sm p-button-outlined p-button-secondary'}
                tooltip={mini ? 'Validar estatus GPS' : undefined}
                onClick={onClick}
                loading={loading}
                disabled={disabled || !dispositivoId}
            />
            <OverlayPanel ref={op} style={{ maxWidth: '300px' }}>
                {res && (
                    <div>
                        <div className={`font-bold mb-2 ${res.usar ? 'text-green-600' : 'text-red-600'}`}>
                            {res.usar ? 'USAR ✔' : 'NO USAR ✖'}
                        </div>
                        {res.nombre && <div className="text-sm font-medium">{res.nombre}</div>}
                        <div className="text-sm">{res.mensaje}</div>
                        {res.ultimaPosicion && <div className="text-xs text-color-secondary mt-1">Última posición: {res.ultimaPosicion}</div>}
                    </div>
                )}
            </OverlayPanel>
        </>
    );
};
